import { render, staticRenderFns } from "./ProductComments.vue?vue&type=template&id=33508ab9&scoped=true"
import script from "./ProductComments.vue?vue&type=script&lang=js"
export * from "./ProductComments.vue?vue&type=script&lang=js"
import style0 from "./ProductComments.vue?vue&type=style&index=0&id=33508ab9&prod&scoped=true&lang=css"
import style1 from "./ProductComments.vue?vue&type=style&index=1&id=33508ab9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33508ab9",
  null
  
)

export default component.exports